import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const gcpNetworkDiagramPlugin = createPlugin({
  id: 'gcp-network-diagram',
  routes: {
    root: rootRouteRef,
  },
});

export const GcpNetworkDiagramPage = gcpNetworkDiagramPlugin.provide(
  createRoutableExtension({
    name: 'GcpNetworkDiagramPage',
    component: () =>
      import('./components/NetworkDiagramPage').then(m => m.NetworkDiagramPage),
    mountPoint: rootRouteRef,
  }),
);
